export const NOTIFICATION_DURATION = 5000;

export const notificationVariants = {
  initial: {
    x: '120%',
    opacity: 0,
    scale: 0.9,
  },
  animate: {
    x: 0,
    opacity: 1,
    scale: 1,
    transition: {
      type: 'spring' as const,
      stiffness: 400,
      damping: 25,
    },
  },
  exit: {
    x: '120%',
    opacity: 0,
    scale: 0.9,
    transition: {
      duration: 0.2,
      ease: 'easeInOut' as const,
    },
  },
  hover: {
    scale: 1.02,
    transition: {
      duration: 0.2,
    },
  },
} as const;
